/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalChatStore } from '#app/routes/chat+/index.tsx'

type UseSetTitleParams = {
	titleFetcher: any
	titleHasBeenSet: boolean
}

export function useSetTitle({
	titleFetcher,
	titleHasBeenSet,
}: UseSetTitleParams) {
	const dispatch = useGlobalChatStore(useShallow(state => state.dispatch))

	useEffect(() => {
		if (
			titleFetcher.data &&
			titleFetcher.data.type === 'set_new_title' &&
			!titleHasBeenSet
		) {
			dispatch({
				type: 'SET_TITLE',
				title: titleFetcher.data.title,
				editOrCreate: 'create',
			})
		}
	}, [titleFetcher])
}
